import React, {
    useState,
    useEffect
} from 'react';
import {
    Table,
    Container,
    FormControl,
    DropdownButton,
    Dropdown,
    Accordion,
    AccordionToggle,
    AccordionCollapse,
    Card,
    InputGroup
} from 'react-bootstrap';
import '../../styles/MembersTable.css';
import { HHIEButton } from '../utility/HHIEButton';

export default function AdminEmails(props) {
    const [loadingEmails, setLoadingEmails] = useState(true);
    const [emails, setEmails] = useState(null)

    useEffect(() => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }

            fetch('/api/admin/getEmails/' + sfid)
                .then((emailResponse) => {
                    emailResponse.json()
                        .then((emailJson) => {
                            if (emailJson.errors !== null && emailJson.errors !== "") alert(emailJson.errors);
                            setEmails(emailJson.message);
                            setLoadingEmails(false);
                        })
                        .catch((emailError) => {
                            console.log("Emails json error: " + emailError);
                        })
                })
        }

    }, [props])


    const handleSubmit = () => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }
            var formData = new FormData();
            formData.append("emailsLength", emails.length);

            for (var idx = 0; idx < emails.length; idx++) {
                formData.append("emailsId" + idx, emails[idx].id);
                formData.append("emailsName" + idx, emails[idx].name);
                formData.append("emailsSubject" + idx, emails[idx].subject);
                formData.append("emailsMessage" + idx, emails[idx].message);
                formData.append("emailsPotentials" + idx, emails[idx].potentialValues);
                // return
            }

            const fetchOptions = {
                method: 'POST',
                body: formData
            }
            fetch('api/admin/UpdateEmails/' + sfid, fetchOptions)
                .then((response) => {
                    response.json()
                        .then((text) => {
                            var fullMessage = "Submit:\n" + text.message + ((text.errors !== null && text.errors !== "") ? ("\nErrors:\n" + test.Errors) : "");
                            alert(fullMessage);
                        })
                        .catch((error) => {
                            console.log("Submit text error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Submit response error: " + error);
                })
        }
    }

    const handleUpdatedEmailMessage = (email, value) => {
        let Obj = emails.filter(currentEmail => {
            if (currentEmail === email) {
                value = value.replaceAll("<", "").replaceAll(">", "");
                currentEmail.message = value
            }
            return true;
        })
        setEmails(Obj)
    }
    const handleUpdatedEmailSubject = (email, value) => {
        let Obj = emails.filter(currentEmail => {
            if (currentEmail === email) {
                value = value.replaceAll("<", "").replaceAll(">", "");
                currentEmail.subject = value
            }
            return true;
        })
        setEmails(Obj)
    }

    const renderExternalEmailAccordions = () => {
        var externalEmails = emails.filter(email => email.isExternal);
        return externalEmails.map((email, idx) => {
            var i = idx + 1;
            return (
                <Container key={i + "-external-container"}>
                    <AccordionToggle as={Card} eventKey={i} border="secondary" bg="light" text="black">
                        <div style={{ paddingTop: 5, paddingBottom: 5, fontSize: 17, textAlign: "center" }} >{email.name}</div>
                    </AccordionToggle>

                    <AccordionCollapse as={Card} eventKey={i}>
                        <Table className="border border-secondary">
                            {renderEmail(email, "external"+i)}
                        </Table>
                    </AccordionCollapse>
                </Container>
            )
        })
    }

    const renderInternalEmailAccordions = () => {
        var internalEmails = emails.filter(email => !email.isExternal);


        return internalEmails.map((email, idx) => {
            var i = idx + 1;
            return (
                <Container key={i + "-internal-container"}>
                    <AccordionToggle as={Card} eventKey={i} border="secondary" bg="light" text="black">
                        <div style={{ paddingTop: 5, paddingBottom: 5, fontSize: 17, textAlign: "center" }} >{email.name}</div>
                    </AccordionToggle>

                    <AccordionCollapse as={Card} eventKey={i}>
                        <Table className="border border-secondary">
                                {renderEmail(email,"internal"+i)}
                        </Table>
                    </AccordionCollapse>
                </Container>
            )
        })
    }

    const renderEmail = (email,idx) => {
        return (
            <tbody key={"email" + idx}>
                <tr key={"subjectLabel" + idx}><th>Subject</th></tr>
                <tr key={"subject" + idx}>
                    <td>
                        <FormControl
                            value={email.subject}
                            onChange={(e) => { handleUpdatedEmailSubject(email, e.target.value) }}
                        />
                    </td>
                </tr>
                <tr key={"messageLabel" + idx}><th>Message</th></tr>
                <tr key={"message" + idx}>
                    <td>
                        <InputGroup>
                        <FormControl
                            id={"message-"+idx}
                            as="textarea"
                            rows={email.message.split("\n").length + 6 }
                            value={email.message}
                            onChange={(e) => { handleUpdatedEmailMessage(email, e.target.value) }}
                            />
                        </InputGroup>
                    </td>
                </tr >
                <tr key={"potentialsLabel" + idx}><th>Potential values to include in the message. Please make sure the text entered matches exactly what is shown below</th></tr>
                <tr key={"potentials" + idx}>
                    <td>
                        { email.potentialValues}
                    </td>
                </tr >
            </tbody>
            )
    }

    var externalContents = loadingEmails ? "Loading" : renderExternalEmailAccordions();
    var internalContents = loadingEmails ? "Loading" : renderInternalEmailAccordions();

    return (
        <Container className="entire-table">
            <br />
            <h2>Emails</h2>
            <br />
            <h4 className="d-flex justify-content-center">External Emails Sent to POCs</h4>
            <Accordion defaultActiveKey={1}>
                {externalContents}
            </Accordion>
            <br/>
            <h4 className="d-flex justify-content-center">Internal Emails Sent only within HHIE</h4>
            <Accordion defaultActiveKey={1}>
                {internalContents}
            </Accordion>
            <br />
            <div className="d-flex justify-content-center" style={{ marginBottom: '40px' }}>
                <HHIEButton
                    id="config-submit"
                    variant="secondary"
                    type="submit"
                    onClick={() => { handleSubmit() }}
                    title="Submit"
                />
            </div>
        </Container>
    )
}